import React from 'react';

import CustomersFilters from './customers-filters/CustomersFilters';
import CustomersTable from './customers-table/CustomersTable';

const CustomersList = () => {
  return (
    <>
      <CustomersFilters />
      <CustomersTable />
    </>
  );
};

export default CustomersList;
